<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <!-- <form @submit.prevent="setFilter"> -->
        <h6 class="heading-small text-muted mb-4">Search</h6>
        <div class="row">
          <div class="col">
            <form @submit.prevent="setFilter">
              <a-input
                placeholder="Search by"
                v-model="table.filters.user_name"
              >
                <a-select
                  slot="addonAfter"
                  default-value="user_name"
                  style="width: 110px"
                >
                  <a-select-option value="user_name">
                    Username
                  </a-select-option>
                </a-select>
              </a-input>
            </form>
          </div>
        </div>
        <!-- </form> -->
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
          :sortOrder="table.sortOrder"
        >
          <template #headerButtons>
            <base-button
              id="new"
              v-if="source === 'clp'"
              class="float-right ml-1"
              type="primary"
              size="sm"
              @click="openDrawer()"
              >+ Create User</base-button
            >
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <UserForm
                :viewMode="viewMode"
                :userData="userData"
                :systemModules="systemModules"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{ tableProps }">
            <button
              id="view"
              class="btn btn-success btn-sm"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              View
            </button>

            <button
              id="edit"
              class="btn btn-warning btn-sm"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              Edit
            </button>
            <a-popconfirm
              title="You are about to deactivate this record?"
              v-if="source && !isNonBxi"
              @confirm="deleteRow(tableProps.rowData)"
              okText="Delete"
              cancelText="Cancel"
            >
              <a class="btn btn-danger btn-sm text-white">Deactivate</a>
            </a-popconfirm>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import UserForm from './UserForm.vue';
import HTTPRequest from '@/controllers/httpRequest';
import secureStorage from '@/controllers/secureStorage';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    UserForm
  },
  data() {
    return {
      gradientType: 'gradient-blue',
      userData: null,
      systemModules: null,
      source: secureStorage.getItem('source'),
      drawer: {
        visible: false,
        width: 800,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'Users',
        apiUrl: '/api/v1/users',
        fields: [
          'actions',
          { name: 'user_name', title: 'Username' },
          'email',
          { name: 'userGroup.name', title: 'User Group' }
        ],
        sortOrder: [
          {
            field: 'id',
            direction: 'asc'
          }
        ],
        filters: {
          user_name: null
        }
      },

      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      }
    };
  },
  methods: {
    async openDrawer(rowData = null) {
      this.userData = rowData;

      this.viewMode = event.target.id == 'view' ? true : false;
      this.drawer.visible = true;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.userData = null;
    },

    setFilter() {
      this.$root.$emit('refreshTable');
    },
    async deleteRow(rowData) {
      const userId = rowData.id;
      const response = await HTTPRequest.deleteRequest(
        `/api/v1/users/${userId}`
      );

      if (response.message == 'Success') {
        this.$notification.success({
          message: 'Success'
        });
        this.$root.$emit('refreshTable');
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
    }
  },
  computed: {
    isNonBxi() {
      return this.source !== 'clp' || false;
    }
  }
};
</script>

<style scoped></style>
